// Replace bixgrow social icons with theme's SVG icons
(function() {
  // Theme SVG icons mapping - using same icons as product page share (.m-sharing-social)
  const themeIcons = {
    facebook: '<svg class="m-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>',
    twitter: '<svg class="m-svg-icon" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0385131 0L6.1373 8.15756L0 14.79H1.38126L6.75446 8.9832L11.0959 14.79H15.7963L9.3544 6.17359L15.067 0H13.6857L8.73725 5.34795L4.739 0H0.0385131ZM2.06976 1.0178H4.22917L13.7648 13.772H11.6054L2.06976 1.0178Z" fill="currentColor"/></svg>',
    whatsapp: '<svg class="m-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>',
    email: '<svg class="m-svg-icon" viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M125.4 128C91.5 128 64 155.5 64 189.4C64 190.3 64 191.1 64.1 192L64 192L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 192L575.9 192C575.9 191.1 576 190.3 576 189.4C576 155.5 548.5 128 514.6 128L125.4 128zM528 256.3L528 448C528 456.8 520.8 464 512 464L128 464C119.2 464 112 456.8 112 448L112 256.3L266.8 373.7C298.2 397.6 341.7 397.6 373.2 373.7L528 256.3zM112 189.4C112 182 118 176 125.4 176L514.6 176C522 176 528 182 528 189.4C528 193.6 526 197.6 522.7 200.1L344.2 335.5C329.9 346.3 310.1 346.3 295.8 335.5L117.3 200.1C114 197.6 112 193.6 112 189.4z"></path></svg>'
  };

  function detectSocialNetwork(href, element) {
    if (!href) return null;
    href = href.toLowerCase();
    if (href.includes('facebook.com') || href.includes('fb.com')) return 'facebook';
    if (href.includes('twitter.com') || href.includes('x.com')) return 'twitter';
    if (href.includes('whatsapp.com') || href.includes('wa.me')) return 'whatsapp';
    if (href.includes('mailto:') || href.includes('email')) return 'email';
    return null;
  }

  function replaceIcons() {
    const container = document.querySelector('.bixgrow-share-social-container');
    if (!container) return;

    // Directly target email icon by ID
    if (themeIcons.email) {
      const emailBtn = document.querySelector('#email-share-btn');
      if (emailBtn) {
        const svg = emailBtn.querySelector('svg');
        const img = emailBtn.querySelector('img');
        // Check if it's already our icon by checking for the specific viewBox
        const existingSvg = emailBtn.querySelector('svg[viewBox="0 0 640 640"]');
        if (!existingSvg) {
          if (svg) {
            svg.outerHTML = themeIcons.email;
          } else if (img) {
            img.outerHTML = themeIcons.email;
          } else {
            // No icon found, add ours
            emailBtn.insertAdjacentHTML('afterbegin', themeIcons.email);
          }
        }
      }
    }

    // Get all links and buttons
    const links = container.querySelectorAll('a, button');
    links.forEach(link => {
      // Skip email button as we already handled it above
      if (link.id === 'email-share-btn') return;
      
      const href = link.getAttribute('href') || '';
      const ariaLabel = (link.getAttribute('aria-label') || '').toLowerCase();
      const className = (link.className || '').toLowerCase();
      const textContent = (link.textContent || '').toLowerCase();
      const img = link.querySelector('img');
      const svg = link.querySelector('svg');
      
      // Detect network - be more aggressive with email detection
      let network = detectSocialNetwork(href, link);
      if (!network) {
        if (ariaLabel.includes('email') || className.includes('email') || textContent.includes('email') || 
            (img && (img.alt || img.src || '').toLowerCase().includes('email'))) {
          network = 'email';
        }
      }
      
      if (network && themeIcons[network]) {
        // Always replace SVG if it exists
        if (svg) {
          svg.outerHTML = themeIcons[network];
        }
        // Replace image if exists (for email icon loaded as image)
        else if (img) {
          img.outerHTML = themeIcons[network];
        }
        // If neither exists, insert SVG at the beginning
        else {
          link.insertAdjacentHTML('afterbegin', themeIcons[network]);
        }
      }
    });

    // Force replace email icons - check all links with mailto or email-related content (fallback)
    if (themeIcons.email) {
      // Find all potential email links
      const allLinks = container.querySelectorAll('a, button');
      allLinks.forEach(link => {
        // Skip if already handled
        if (link.id === 'email-share-btn') return;
        
        const href = (link.getAttribute('href') || '').toLowerCase();
        const ariaLabel = (link.getAttribute('aria-label') || '').toLowerCase();
        const className = (link.className || '').toLowerCase();
        
        // If this looks like an email link, force replace its icon
        if (href.includes('mailto:') || href.includes('email') || ariaLabel.includes('email') || className.includes('email')) {
          const svg = link.querySelector('svg');
          const img = link.querySelector('img');
          // Always replace - check if it's already our icon by checking for the specific viewBox
          const existingSvg = link.querySelector('svg[viewBox="0 0 640 640"]');
          if (!existingSvg) {
            if (svg) {
              svg.outerHTML = themeIcons.email;
            } else if (img) {
              img.outerHTML = themeIcons.email;
            } else {
              // No icon found, add ours
              link.insertAdjacentHTML('afterbegin', themeIcons.email);
            }
          }
        }
      });

      // Also check for any standalone email icons that might not be in links
      const allSvgs = container.querySelectorAll('svg');
      allSvgs.forEach(svg => {
        const parent = svg.closest('a, button');
        if (!parent || !parent.querySelector('svg[class*="m-svg-icon"]')) {
          // Check if this SVG looks like an email icon
          const svgContent = svg.outerHTML.toLowerCase();
          if (svgContent.includes('mail') || svgContent.includes('envelope') || svgContent.includes('email')) {
            svg.outerHTML = themeIcons.email;
          }
        }
      });

      const allImgs = container.querySelectorAll('img');
      allImgs.forEach(img => {
        const parent = img.closest('a, button');
        if (!parent || !parent.querySelector('svg')) {
          const imgSrc = (img.src || '').toLowerCase();
          const imgAlt = (img.alt || '').toLowerCase();
          if (imgSrc.includes('email') || imgSrc.includes('mail') || imgAlt.includes('email') || imgAlt.includes('mail')) {
            img.outerHTML = themeIcons.email;
          }
        }
      });
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceIcons);
  } else {
    replaceIcons();
  }

  // Also run after a delay to catch dynamically loaded content
  setTimeout(replaceIcons, 1000);
  setTimeout(replaceIcons, 3000);

  // Watch for changes in the container
  const observer = new MutationObserver(() => {
    replaceIcons();
    setupEmailClickHandler();
  });

  const container = document.querySelector('.bixgrow-share-social-container');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }

  // Handle email button click - prevent page navigation while opening mail client
  // Use capture phase to intercept before bixgrow's handlers
  function setupEmailClickHandler() {
    const emailBtn = document.querySelector('#email-share-btn');
    if (emailBtn && !emailBtn.dataset.clickHandlerAdded) {
      const originalHref = emailBtn.getAttribute('href');
      
      // Add click handler in capture phase (runs before other handlers)
      emailBtn.addEventListener('click', function(e) {
        const href = this.getAttribute('href') || originalHref;
        
        if (href && href.startsWith('mailto:')) {
          // Stop all event propagation to prevent bixgrow's handlers
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Open mail client directly - mailto links open mail client, not a page
          // We use a temporary link to trigger it without navigation
          const tempLink = document.createElement('a');
          tempLink.href = href;
          tempLink.style.position = 'absolute';
          tempLink.style.left = '-9999px';
          document.body.appendChild(tempLink);
          
          // Trigger the mailto link
          tempLink.click();
          
          // Clean up immediately
          setTimeout(function() {
            try {
              document.body.removeChild(tempLink);
            } catch (err) {
              // Ignore cleanup errors
            }
          }, 0);
          
          // Keep focus on current window to prevent navigation
          window.focus();
        }
        
        return false;
      }, true); // true = capture phase
      
      emailBtn.dataset.clickHandlerAdded = 'true';
    }
  }

  // Setup email click handler on load
  setupEmailClickHandler();
  
  // Also setup after delays to catch dynamically loaded content
  setTimeout(setupEmailClickHandler, 1000);
  setTimeout(setupEmailClickHandler, 3000);

  // Replace bg-modal close button SVG with compatibility modal's close button SVG
  function replaceBgCloseIcon() {
    const bgCloseButtons = document.querySelectorAll('.bg-modal .bg-close, .bg-modal-content .bg-close');
    
    // Compatibility modal close button SVG (same as theme's standard modal close)
    const closeIconSVG = '<svg class="m-svg-icon" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg>';
    
    bgCloseButtons.forEach(button => {
      if (!button.dataset.iconReplaced) {
        const existingSvg = button.querySelector('svg');
        const existingIcon = button.querySelector('svg[viewBox="0 0 320 512"]');
        
        // Only replace if it's not already the correct icon
        if (!existingIcon) {
          if (existingSvg) {
            existingSvg.outerHTML = closeIconSVG;
          } else {
            // No SVG found, insert it
            button.insertAdjacentHTML('afterbegin', closeIconSVG);
          }
        }
        button.dataset.iconReplaced = 'true';
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceBgCloseIcon);
  } else {
    replaceBgCloseIcon();
  }

  // Also run after delays to catch dynamically loaded modals
  setTimeout(replaceBgCloseIcon, 500);
  setTimeout(replaceBgCloseIcon, 1000);
  setTimeout(replaceBgCloseIcon, 2000);

  // Watch for bg-modal elements being added to the DOM
  const bgModalObserver = new MutationObserver(() => {
    replaceBgCloseIcon();
  });

  // Observe the document body for new bg-modal elements
  bgModalObserver.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
})();

